import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";
import { timStore, selectionStore } from "@/hooks";
import { PanelCard, List, ListItem, IconButton } from "@/components/common";


/**
 * Displays that other artifact levels that the selected artifact type traces to.
 */
const __default__ = {
  name: "ArtifactLevelTraces",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const artifactLevel = computed(() => timStore.selectedArtifactLevel);
const name = computed(() => artifactLevel.value?.name || "");

const parentTypes = computed(() => timStore.getParentMatrices(name.value));
const parentCount = computed(() => parentTypes.value?.length || 0);
const parentLabel = computed(() =>
  parentCount.value === 1
    ? "1 Parent Type"
    : `${parentCount.value} Parent Types`
);

const childTypes = computed(() => timStore.getChildMatrices(name.value));
const childCount = computed(() => childTypes.value?.length || 0);
const childLabel = computed(() =>
  childCount.value === 1 ? "1 Child Type" : `${childCount.value} Child Types`
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (parentCount.value > 0)
      ? (_openBlock(), _createBlock(_unref(PanelCard), {
          key: 0,
          title: parentLabel.value,
          collapsable: "",
          borderless: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(List), {
              "scroll-height": 300,
              "data-cy": "list-selected-parents",
              class: "bg-background rounded"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parentTypes.value, (parent) => {
                  return (_openBlock(), _createBlock(_unref(ListItem), {
                    key: parent.typeId,
                    clickable: "",
                    title: parent.name,
                    "icon-id": _unref(timStore).getTypeIcon(parent.name),
                    color: _unref(timStore).getTypeColor(parent.color),
                    "action-cols": 1,
                    "data-cy": "list-selected-parent-item",
                    onClick: ($event: any) => (_unref(selectionStore).selectArtifactLevel(parent.name))
                  }, {
                    actions: _withCtx(() => [
                      _createVNode(_unref(IconButton), {
                        outline: "",
                        flat: false,
                        icon: "trace",
                        tooltip: "View Trace Matrix",
                        "data-cy": "button-selected-parent-link",
                        class: "trace-chip text-nodeDefault",
                        onClick: ($event: any) => (_unref(selectionStore).selectTraceMatrix(name.value, parent.name))
                      }, null, 8, ["onClick"])
                    ]),
                    _: 2
                  }, 1032, ["title", "icon-id", "color", "onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true),
    (childCount.value > 0)
      ? (_openBlock(), _createBlock(_unref(PanelCard), {
          key: 1,
          title: childLabel.value,
          collapsable: "",
          borderless: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(List), {
              "scroll-height": 300,
              "data-cy": "list-selected-children",
              class: "bg-background rounded"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(childTypes.value, (child) => {
                  return (_openBlock(), _createBlock(_unref(ListItem), {
                    key: child.typeId,
                    clickable: "",
                    title: child.name,
                    "icon-id": _unref(timStore).getTypeIcon(child.name),
                    color: child.color,
                    "action-cols": 1,
                    "data-cy": "list-selected-child-item",
                    onClick: ($event: any) => (_unref(selectionStore).selectArtifactLevel(child.name))
                  }, {
                    actions: _withCtx(() => [
                      _createVNode(_unref(IconButton), {
                        outline: "",
                        flat: false,
                        icon: "trace",
                        tooltip: "View Trace Matrix",
                        "data-cy": "button-selected-child-link",
                        class: "trace-chip text-nodeDefault",
                        onClick: ($event: any) => (_unref(selectionStore).selectTraceMatrix(child.name, name.value))
                      }, null, 8, ["onClick"])
                    ]),
                    _: 2
                  }, 1032, ["title", "icon-id", "color", "onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true)
  ]))
}
}

})